import type { ButtonHTMLAttributes, ReactNode } from "react";

type AppButtonVariant = "primary" | "secondary" | "ghost" | "danger";

interface AppButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: AppButtonVariant;
  children: ReactNode;
}

const VARIANT_CLASS: Record<AppButtonVariant, string> = {
  primary:
    "bg-[var(--tg-theme-button-color,#3390ec)] text-[var(--tg-theme-button-text-color,#ffffff)]",
  secondary:
    "border border-black/10 bg-[var(--tg-theme-secondary-bg-color,#f4f4f5)] text-[var(--tg-theme-text-color,#000)]",
  ghost: "text-[var(--tg-theme-link-color,#3390ec)]",
  danger: "border border-red-200 text-red-600",
};

export function AppButton({
  variant = "primary",
  className = "",
  children,
  ...props
}: AppButtonProps) {
  return (
    <button
      type="button"
      className={`inline-flex min-h-11 items-center justify-center rounded-[16px] px-4 py-3 text-sm font-medium transition active:opacity-80 disabled:opacity-50 ${VARIANT_CLASS[variant]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
}
